import React, { useEffect, useRef } from 'react';

const CHARS = 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲン0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ<>{}[]|/\\=+*&^%$#@!';

export default function MatrixRain({ opacity = 0.06, speed = 1 }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');

    let w, h, columns, drops, brightness;

    const resize = () => {
      w = canvas.width = window.innerWidth;
      h = canvas.height = window.innerHeight;
      columns = Math.floor(w / 16);
      drops = Array.from({ length: columns }, () => Math.random() * -100);
      brightness = Array.from({ length: columns }, () => Math.random() * 0.5 + 0.3);
    };

    resize();
    window.addEventListener('resize', resize);

    const draw = () => {
      // Slower fade = more visible trails
      ctx.fillStyle = 'rgba(0, 0, 0, 0.04)';
      ctx.fillRect(0, 0, w, h);

      for (let i = 0; i < drops.length; i++) {
        const char = CHARS[Math.floor(Math.random() * CHARS.length)];
        const x = i * 16;
        const y = drops[i] * 16;

        // Head of the column — bright white-blue
        const isHead = drops[i] > 0 && drops[i] < 3;
        if (isHead) {
          ctx.fillStyle = '#e0f0ff';
          ctx.globalAlpha = 0.95;
          ctx.shadowColor = '#60a5fa';
          ctx.shadowBlur = 12;
        } else {
          // Trail — varying blue intensities
          const b = brightness[i];
          const green = Math.floor(80 + b * 80);
          const blue = Math.floor(180 + b * 75);
          ctx.fillStyle = `rgb(30, ${green}, ${blue})`;
          ctx.globalAlpha = Math.random() * 0.4 + b;
          ctx.shadowColor = 'transparent';
          ctx.shadowBlur = 0;
        }

        ctx.font = `${isHead ? 'bold ' : ''}14px monospace`;
        ctx.fillText(char, x, y);

        if (y > h && Math.random() > 0.975) {
          drops[i] = 0;
          brightness[i] = Math.random() * 0.5 + 0.3;
        }
        drops[i] += speed;
      }
      ctx.globalAlpha = 1;
      ctx.shadowBlur = 0;
    };

    const interval = setInterval(draw, 45);

    return () => {
      clearInterval(interval);
      window.removeEventListener('resize', resize);
    };
  }, [speed]);

  return (
    <canvas
      ref={canvasRef}
      className="fixed inset-0 pointer-events-none z-0"
      style={{ opacity }}
      data-testid="matrix-rain"
    />
  );
}
